<template>
  <div class="logistics-box">
    <!-- 收寄信息 -->
    <div class="header">
      <!-- 竖线 -->
      <div class="Vertical-line"></div>
      <div class="header-item">
        <div class="type ji">寄</div>
        <div class="info">
          <p class="name-phone">
            <span class="name">{{ detailInfo.purchaser  }}</span>
            <span class="phone">{{ detailInfo.telephone  }}</span>
          </p>
          <p class="address">{{ detailInfo.visitorAddress}}</p>
          <!-- 分割线 -->
          <!-- <div class="divider"></div> -->
        </div>
      </div>
      <div class="header-item">
        <div class="type shou">收</div>
        <div class="info">
          <p class="name-phone">
            <span class="name">{{ expressList[0].deliveryContact  }}</span>
            <span class="phone">{{ expressList[0].deliveryContactTel  }}</span>
          </p>
          <p class="address">{{ expressList[0].deliveryAddress }}</p>
        </div>
      </div>
    </div>
    <div class="addresscode">
      <div class="left-box">
        <div class="name">{{ expressList[0].expressCompany }}</div>
        <span class="line">|</span>
        <span class="code">{{ expressList[0].expressNo }}</span>
      </div>
      <div class="right-box"
        v-clipboard:error="copyError"
        v-clipboard:copy="expressList[0].expressNo"
        v-clipboard:success="copySuccess">复制</div>
    </div>
    <!-- 物流详细内容 -->
    <div class="logistics-content">
      <div v-if="datalist && datalist.length > 0" class="logistics-list">
        <div
          v-for="(item, index) in datalist"
          :key="index"
          class="logistics-item"
          :class="[index === 0 ? 'current' : 'success', ]"
          :style="{'border-left': index === datalist.length - 1 ? 'none' : '1px solid #36b374'}"
        >
          <div class="Filled-circle" :class="index === 0 ? 'curren-step' : 'success-step'"></div>
          <p class="title">
            <span
              v-if="index === 0 && State == 3"
              class="status"
              :class="{'fontweight500': index === 0}"
            >{{ '已签收' }}</span>
            <span
              v-else-if="index === datalist.length - 1"
              class="status"
              :class="{'fontweight500': index === 0}"
            >{{ '快件已收取' }}</span>
            <span
              v-else-if="item.Action == 202"
              class="status"
              :class="{'fontweight500': index === 0}"
            >{{ '派送中' }}</span>
            <span v-else class="status" :class="{'fontweight500': index === 0}">{{ '运输中' }}</span>
            <span class="time">{{ item.AcceptTime | timefilter }}</span>
          </p>
          <p class="content" :class="{'fontweight400': index === 0}">{{ item.AcceptStation }}</p>
        </div>
      </div>
      <div v-else style="text-align: center;">未查询到相关物流信息</div>
    </div>
    <!-- 底部确认收货按钮 -->
    <div v-if="operationList.includes('CONFIRM_RECEIPT')" class="confirm" @click="sendAccept">
      <div class="confirm-btn">确认收货</div>
    </div>
    <accept ref="accept" @sendAccept="sendAccept"></accept>
  </div>
</template>
<script>
    import api from '../../../service/modules/refund';
    import accept from '../views/pages/confirmAccept';
    import { Dialog } from 'vant';

    export default {
        components: { accept },
        filters: {
            nameFilter (val) {
                const strLen = val.length
                let newStr = val.substr(0, 1)
                for (let i = 0; i < strLen - 1; i++) {
                    newStr += '*'
                }
                return newStr
            },
            phoneFilter (val) {
                return val.substr(0, 2) + '******' + val.substr(9);
            },
            timefilter (val) {
                const splitStr = val.split(' ');
                return `${splitStr[0].substr(5, 2)}/${splitStr[0].substr(
                    8,
                    2
                )} ${splitStr[1].substr(0, 5)}`;
            }
        },
        data () {
            return {
                receiver: {
                    name: '张',
                    phone: 10086,
                    address: '申迪'
                }, // 收货人信息
                shipper: {
                    name: '码云',
                    phone: 10086,
                    address: '北京'
                }, // 寄货人信息
                flowId: 0,
                datalist: [
                //     {
                //       Action: 1,
                //       AcceptStation: "顺丰速运 已收取快件",
                //       AcceptTime: "2021-09-13 08:36:37"
                //     },
                //     {
                //       Action: 1,
                //       AcceptStation: "顺丰速运 已收取快件",
                //       AcceptTime: "2021-09-13 08:36:37"
                //     },
                //     {
                //       Action: 1,
                //       AcceptStation: "顺丰速运 已收取快件",
                //       AcceptTime: "2021-09-13 08:36:37"
                //     },
                //     {
                //       Action: 2,
                //       AcceptStation: "快件到达 【上海浦江中转场】",
                //       AcceptTime: "2021-09-13 08:36:37"
                //     },
                //     {
                //       Action: 202,
                //       AcceptStation:
                //         "快件交给孙代付,正在派送途中（联系电话：15288184429,顺丰已开启“安全呼叫”保护您的电话隐私,请放心接听！）（主单总件数：1件）",
                //       AcceptTime: "2021-09-13 08:36:37"
                //     },
                //        {
                //       Action: 202,
                //       AcceptStation:
                //         "快件交给孙代付,正在派送途中（联系电话：15288184429,顺丰已开启“安全呼叫”保护您的电话隐私,请放心接听！）（主单总件数：1件）",
                //       AcceptTime: "2021-09-13 08:36:37"
                //     },
                //        {
                //       Action: 202,
                //       AcceptStation:
                //         "快件交给孙代付,正在派送途中（联系电话：15288184429,顺丰已开启“安全呼叫”保护您的电话隐私,请放心接听！）（主单总件数：1件）",
                //       AcceptTime: "2021-09-13 08:36:37"
                //     },
                //        {
                //       Action: 202,
                //       AcceptStation:
                //         "快件交给孙代付,正在派送途中（联系电话：15288184429,顺丰已开启“安全呼叫”保护您的电话隐私,请放心接听！）（主单总件数：1件）",
                //       AcceptTime: "2021-09-13 08:36:37"
                //     },
                //     {
                //       Action: 302,
                //       AcceptStation:
                //         "您的快件代签收（速递易），如有疑问请电联快递员【孙代付，电话：15288184429】。疫情期间顺丰每日对网点消毒、快递员每日测温、配戴口罩，感谢您使用顺丰，期待再次为您服务。（主单总件数：1件）",
                //       AcceptTime: "2021-09-13 08:36:37"
                //     }
                ], // 快递数据
                addressInfo: [],
                State: 3, // 快速状态，3：快递已签收，2：正在运输
                detailInfo: {}, // 退货单详情
                operationList: [],
                expressList: []
            };
        },
        created () {
            this.flowId = this.$route.query.data.flowId;
            this.detailInfo = this.$route.query.data;
            this.addressInfo = this.$route.query.addressInfo;
            // 获取物流信息
            this.getdata();
            this.expressList = this.$store.state.refund.detail.expressList
            this.operationList = this.$store.state.refund.detail.operationList
        },
        methods: {
          copySuccess() {
            this.$Toast("复制成功");
          },
          copyError() {
            this.$Toast("复制失败!");
          },
            // 获取物流信息
            getdata () {
                if (this.addressInfo.length > 0) {
                    api.track({ expressId: this.addressInfo[0].expressId }).then(res => {
                        if (res.ret === 0) {
                            this.State = JSON.parse(res.data).State;
                            this.datalist = JSON.parse(res.data).Traces.reverse();
                        }
                    });
                }
            },
            // 确认收货
            sendAccept () {
                Dialog.confirm({
                    title: '是否确认收货？',
                    message: '请收到商品后确认无误再确认收货',
                    confirmButtonColor: '#36B374'
                })
                    .then(() => {
                        api.confirmReceipt({ flowId: this.flowId }).then(res => {
                            if (res.ret === 0) {
                                this.$Toast.success({
                                    message: '收货成功'
                                });
                                this.$router.back();
                            } else {
                                this.$Toast({
                                    message: res.msg
                                });
                            }
                        });
                        // on confirm
                    })
            }
        }
    };
</script>

<style lang="less" scoped>
.logistics-box {
  padding-bottom: 85px;
  .header {
    position: relative;
    padding: 0 16px;
    margin-top: 16px;
    margin-bottom: 8px;
    .Vertical-line {
      position: absolute;
      height: 35px;
      border-right: 1px dashed #D9D9D9;
      top: 69px;
      left: 47px;
    }
    .header-item {
      padding: 24px 16px;
      display: flex;
      background-color: #f8f9fc;
      .divider {
        position: absolute;
        bottom: -23px;
        border: 0.5px solid #eaedf4;
        height: 1px;
        width: 100%;
      }
      .type {
        border-radius: 50%;
        margin-right: 16px;
        font-size: 18px;
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
      }
      .ji {
        color: #36b374;
        background: #54C68D;
        font-weight: 600;
        font-size: 14px;
        color: #FFFFFF;
        margin-top: 6px;

      }
      .shou {
        background: #699FEF;
        font-weight: 600;
        font-size: 14px;
        color: #FFFFFF;
        margin-top: 6px;
      }
      .info {
        position: relative;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;
        .name-phone {
          display: flex;
          align-items: center;
          font-weight: 600;
          font-size: 16px;
          color: #171A1D;
          .name {
            // font-size: 16px;
            color: #171a1d;
            // font-weight: 500;
            vertical-align: middle;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 165px;
            display: inline-block;
          }
          .phone {
            // font-size: 16px;
            // color: #171a1d;
          }
          span {
            &:first-child {
              margin-right: 10px;
            }
          }
        }
        .address {
          margin-top: 10px;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          line-height: 20px;
        }
      }
    }
  }
  .addresscode {
    display: flex;
    justify-content: space-between;
    margin: 0 16px 24px;
    background: #F8F9FC;
    border-radius: 4px;
    padding: 12px;
    .left-box {
      font-size: 14px;
      color: #1E2226;
      display: flex;
      .name {
        font-family: PingFangSC-Medium;
        font-weight: 600;
        word-break: keep-all;
      }
      .line {
        margin: 0 7.5px;
      }
      .code {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        word-break: break-all;
      }
    }
    .right-box {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #229F60;
      text-align: right;
    }
  }

  .logistics-content {
    padding: 0 16px;
    padding-bottom: 60px;
    .Express-type {
      padding: 20px 0;
      border-bottom: 1px solid #f4f4f4;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .circle {
        border-radius: 50%;
        border: 1px solid #36b374;
        margin-right: 3px;
        width: 20px;
        height: 20px;
        background-color: #f7f7f7;
      }
    }
    .logistics-list {
      .logistics-item {
        position: relative;
        padding-left: 15px;
        padding-bottom: 20px;
        .title {
          display: flex;
          align-items: center;
        }
        .Filled-circle {
          position: absolute;
          height: 16px;
          width: 16px;
          border-radius: 50%;
          // background-color: #36b374;
          top: -1px;
          left: -9px;
          background-size: 100% 100%;
          background-color: white;
        }
        .curren-step {
          background-image: url("../../../assets/refund/current.png");
        }
        .success-step {
          background-image: url("../../../assets/refund/confirm.png");
        }
      }
      .current {
        .status {
          font-size: 16px;
          color: #171a1d;
          margin-right: 11px;

        }
        .content {
          font-size: 14px;
          color: #171a1d;
          margin-top: 8px;
          line-height: 20px;
        }
        .time {
          font-size: 12px;
          color: #171a1d;
        }
        .fontweight400 {
          font-size: 14px;
          color: #171a1d;
          font-weight: 400;
        }
      }
      .success {
        .fontweight500 {
          font-size: 16px;
          color: #171a1d;
          font-weight: 500;
        }
        .fontweight400 {
          font-size: 14px;
          color: #171a1d;
          font-weight: 400;
        }
        .status {
          font-size: 16px;
          color: #999999;
          margin-right: 11px;
        }
        .time {
          font-size: 12px;
          color: #a2a3a4;
        }
        .content {
          font-size: 14px;
          color: #999999;
          margin-top: 8px;
          line-height: 20px;
        }
      }
    }
  }
  .confirm {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 8px 16px 34px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-shadow: 0 0 16px 0 rgba(0,0,0,0.05);
    .confirm-btn {
      width: 100%;
      color: white;
      font-size: 16px;
      background-color: #36b374;
      border-radius: 4px;
      text-align: center;
      line-height: 48px;
    }
  }
}
</style>
